import React, {Component, ReactNode} from 'react'
import {createResidentPage, ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import {HideInPC, HideInSP} from '../../styledComponents/ResponsiveConvenience'
import PPStepper from '../shared/PPStepper'
import styled from 'styled-components'
import {FontSize, FontWeights} from '../../styledComponents/Constants'
import {PrimaryStyledButton, StyledSecondaryButton} from '../../styledComponents/Button'
import {Box} from '@mui/material'
import {ColumnFlexContainer} from '../../styledComponents/FlexComponents'
import {votingPreferenceStepsForPc, votingPreferenceStepsForSp} from './ResidentVotingPreferenceMethodSelectionPage'
import {Location} from 'react-router-dom'

export interface ResidentVotingPreferenceCompleteLocationState {
    beforeNetRespondedAssocIdList: number[]
}

interface Props {
    location: Location<ResidentVotingPreferenceCompleteLocationState>
    condominiumCd: string
    generalMeetingId: number
}

interface State {
}

class ResidentVotingPreferenceCompletePage extends Component<Props & ResidentPagePropsSet, State> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)

        this.handleBackToGeneralMeetingDetailButtonClick = this.handleBackToGeneralMeetingDetailButtonClick.bind(this)
        this.handleContinueVotingPreferenceButtonClick = this.handleContinueVotingPreferenceButtonClick.bind(this)
    }

    handleBackToGeneralMeetingDetailButtonClick(): void {
        const {condominiumCd, generalMeetingId} = this.props

        this.props.navigate(
            `/resident/condominiums/${condominiumCd}/general-meetings/${generalMeetingId}`,
        )
    }

    handleContinueVotingPreferenceButtonClick(): void {
        if (!this.props.location.state) {
            return
        }

        const {
            condominiumCd,
            generalMeetingId,
            navigate
        } = this.props
        const beforeNetRespondedAssocIdList = this.props.location.state.beforeNetRespondedAssocIdList

        const nextAssocId = beforeNetRespondedAssocIdList[0]
        if (!nextAssocId) {
            return
        }

        navigate(
            `/resident/condominiums/${condominiumCd}/general-meetings/${generalMeetingId}/assocs/${nextAssocId}/voting-preference/method-selection`,
        )
    }

    render(): ReactNode {
        if (!this.props.location.state) {
            return
        }
        const beforeNetRespondedAssocIdList = this.props.location.state.beforeNetRespondedAssocIdList

        return <>
            <HideInSP>
                <PPStepper steps={votingPreferenceStepsForPc} activeStep={3}/>
            </HideInSP>
            <HideInPC>
                <PPStepper steps={votingPreferenceStepsForSp} activeStep={3} alternativeLabel/>
            </HideInPC>
            <CenterColumnFlexContainer>
                <Box height={'60px'}/>
                <img src={'/resources/images/icons/icon_reserve_complete.svg'} alt={'complete'}/>
                <Box height={'15px'}/>
                <MessageTitle>意思表明が完了しました</MessageTitle>
                <Box height={'15px'}/>
                <MessageDetail>
                    <div>総会への意思が表明されました。</div>
                    <div>意思表明の締切日までは変更が可能です。</div>
                </MessageDetail>
                <Box height={'50px'}/>
                {beforeNetRespondedAssocIdList.length > 0 && <>
                    <PrimaryStyledButton onClick={this.handleContinueVotingPreferenceButtonClick}>
                        続けて意思表明する
                    </PrimaryStyledButton>
                    <Box height={'30px'}/>
                </>}
                <StyledSecondaryButton onClick={this.handleBackToGeneralMeetingDetailButtonClick}>
                    総会詳細へ戻る
                </StyledSecondaryButton>
                <Box height={'15px'}/>
            </CenterColumnFlexContainer>
        </>
    }
}

export default createResidentPage(ResidentVotingPreferenceCompletePage)

const CenterColumnFlexContainer = styled(ColumnFlexContainer)`
  align-items: center;
  text-align: center;
`

const MessageTitle = styled.div`
  font-size: ${FontSize.Big};
  font-weight: ${FontWeights.Bold};
`

const MessageDetail = styled.div`
  font-size: ${FontSize.Middle};
  text-align: center;
`

